import { KeyRounded } from "@mui/icons-material";

export const PATHS = {
  ROOT: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  CONFIRM_EMAIL: "/confirm-email",
  PAYMENT: "/payment",
  RESET_PASSWORD: "/reset-password",
  FORGOT_PASSWORD: "/forget-password",
  COMPANY: "/company",
  PAIEMENT_SUCCESS: "/paiement-success",
  OFFERS: "/offers",
  INVOICES: {
    LIST: "/invoicesList",
    CREATE: "/create-invoice",
  },

  QUOTES: {
    LIST: "/quotesList",
    CREATE: "/create-quote",
  },

  AVOIRS: {
    LIST: "/avoirsList",
    CREATE: "/create-avoir",
  },

  CLIENTS: {
    LIST: "/clients",
    CREATE: "/create-client",
  },
  SIGNATURE: {
    LIST: "/singature",
    CREATE: "/create-client",
    CLIENT: "/sign/:token",
    TABLE_LIST: "/signature-list",
  },
  DOCUMENT: {
    LIST: "/document",
    DETAILS: "folder/:id",
  },

  SUPPLIER: {
    CREATE: "/create-supplier",
    LIST: "/suppliers",
    CONSULT: "/details-supplier/:id",
  },
  EXPENSES: { LIST: "/expenses" },
  ARTICLE: {
    LIST: "/articles",
  },
  CRA: {
    LIST: "/cra",
    DETAILS: "/cra-details/:monthYear",
    VALIDE: "/validation/:craId",
    EDIT: "/cra/:craId",
    CONSULT: "/craConsult/:craId",
    LISTVALIDATION: "/craList",
  },
  HOME: "/home",

  NOT_FOUND: "*",
  CONFIGURATION: "/configuration",

  USERS: {
    LIST: "/users",
  },
  ROLES: {
    LIST: "/roles",
    CREATE: "/create-role",
  },
  DASHBOARD_USER: "/dashboard-user",

  CRADETAILS: "/dashboard-user/cra-details/:id",
  CONGE: {
    LIST: "/conge",
    CREATE: "/create-conge",
    LISTSUPPLIER: "/liste-supplier",
  },
  PROJECT: {
    LIST: "/projects",
    LISTA: "/projects-Admin",

    LISTC: "/projects-collaborateur",
  },
  PACK: {
    LIST: "/packs",
  },
};
